import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { reportReservationChange } from 'modules/accommodations/features/reservations/api';

export const useMutationReportReservationChange = () => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();

  return useMutation(reportReservationChange, {
    onSuccess: data => {
      if (data.success) successToast(t('Reservation change successfully reported'));
    },
    onError: () => errorToast(),
  });
};
